import { layoutMarginSmall } from '@issuu/silkscreen';
import React, { useContext } from 'react';
import styled from 'styled-components';

import DocumentContext from '../DocumentPage/DocumentContext';
import { GoogleAdsTemplate } from './GoogleAdsTemplate';

const Root = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto ${layoutMarginSmall};
    flex-shrink: 0;
`;

type AdType = { network: string };

const NarrowAds = ({ network }: AdType) => (
    <GoogleAdsTemplate
        adSizes={[[320, 50], 'fluid']}
        idSuffix="narrowLeaderBoard"
        isShowInnerTitle={true}
        network={network}
    />
);

const WideAds = ({ network }: AdType) => (
    <GoogleAdsTemplate
        adSizes={[[728, 90], 'fluid']}
        idSuffix="wideLeaderBoard"
        isShowInnerTitle={true}
        network={network}
    />
);

export const AdsLeaderBoard: React.FC = () => {
    const context = useContext(DocumentContext);
    const {
        articleStorySummaries,
        publisher: {
            licenses: { docpageAds },
        },
        appState: {
            currentLayout: { name: layout },
        },
    } = context;

    const network = docpageAds
        ? '/30443627/DocPage_Primary_adConnect'
        : articleStorySummaries.length
        ? '/30443627/DocPage_Sections_Primary'
        : '/30443627/DocPage_Primary';
    return (
        <Root>
            {layout === 'small' ? <NarrowAds network={network} /> : <WideAds network={network} />}
        </Root>
    );
};
